import './donut_pie_chart_view.js.coffee'

class Monitoring.Views.Charts.FullHierarchyPieChartView extends Monitoring.Views.Charts.DonutPieChartView

  events: () ->
    _.extend({}, Monitoring.Views.Charts.DonutPieChartView.prototype.events,
      'click .taxonomyChoise': 'changeTaxonomy',
      'click #change_hierarchy': 'onClickChangeHierarchy'
    )

  initialize: ->
    @title = I18n.t('monitoring.dashboard.charts.h_tags')
    @title_en = I18n.t('monitoring.dashboard.charts.h_tags', {'locale': 'en'})
    super
    @taxonomiesRepository = new Monitoring.Models.TaxonomiesRepository
    @_settings.currentTaxonomyCode = @_settings.currentTaxonomyCode || 'Default'
    @showUndetectedTags = false

  afterAppend: ->
    if @data
      @firstRender = false
      super
    else
      @taxonomiesRepository.loadAlternativeTaxonomies(() =>
        @$el.find('#close_chart').before(@hierarchySelectingTemplate(
          includeAlternativeTaxonomies: Keepcon.currentAccount.includeAlternativeTaxonomies,
          taxonomiesRepository: @taxonomiesRepository
        ))
        query = @searchQuery.toJSON()
        query.taxonomy_code = @_settings.currentTaxonomyCode
        @ajaxCall(@url, query, (response) =>
          @data = response
          @firstRender = true
          super
        )
      )
    return this

  onClickChangeHierarchy: (evt) ->
    @$el.find('#change_hierarchy_menu').toggleClass('taxonomy_dropdown_show')

  changeTaxonomy: (evt) ->
    chosenTaxonomyName = $(evt.target).text()
    @$el.find('#change_hierarchy_menu').toggleClass('taxonomy_dropdown_show')
    taxonomy = @taxonomiesRepository.taxonomyWithName(chosenTaxonomyName)
    @_settings.currentTaxonomyCode = taxonomy.get('code')
    query = @searchQuery.deepCopy()
    query.set('taxonomy_code', @_settings.currentTaxonomyCode)
    @ajaxCall(@url, query.toJSON(), (response) =>
      @data = response
      @afterAppend()
    )

  _formattedLevels: ->
    if @showUndetectedTags
      @data.levels
    else
      @data.levels.map((serie) -> serie.filter((point) -> point.y != 0))

  customOptions: =>
    undetectedTagsOptionText = if @showUndetectedTags
      I18n.t('monitoring.dashboard.charts.hide_undetected_tags')
    else
      I18n.t('monitoring.dashboard.charts.show_undetected_tags')
    undetectedTagsOption = {
      text: undetectedTagsOptionText
      onclick: =>
        @showUndetectedTags = !@showUndetectedTags
        @afterAppend()
    }
    customOptions = super
    customOptions.push(undetectedTagsOption)
    customOptions
